<template>
    <div class="container">
        <div class="row justify-content-md-center main">
            <div class="col-12">
                <h1 class="jumbotron-heading">Impressum</h1>
                <h2><small>Angaben gem. § 5 TMG</small></h2>
                <b>Kontakt:</b>
                <p>Michael Achmann</p>
                <p>Alte Manggasse 2 <br />
                93047 Regensburg<br />
                E-Mail-Adresse: michael@achmann.dev</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AboutElement'
}
</script>

<style scoped>
.main {
    margin-top: 5em;
    display: flex;
    align-items: center;
    text-align: center;
}

</style>
